/**
 * Рабочая область заказа по экологии в карточке клиента (`/orders/:id`, ecology-order): услуга,
 * площадки с результатом и ответы «фотографии» заказа. Пока заказ можно править (черновик или
 * возврат на правки) — кнопка «Открыть мастер заказа».
 */
import { ecologyOrdersApi, type OrderDetail } from '@/lib/api'
import { EcoOrderError, EcoOrderSummary, useEcoOrder } from './order-summary'
import { Panel } from '@/design-system/components/layout/panel'

export function EcologyOrderArea({ order }: { order: OrderDetail }) {
  const { ecoOrder, error } = useEcoOrder((signal) => ecologyOrdersApi.get(order.id, signal))
  if (error) return <EcoOrderError error={error} />
  if (!ecoOrder)
    return (
      <Panel>
        <p className="px-4 py-10 text-center text-txt-secondary">Загрузка…</p>
      </Panel>
    )
  return <EcoOrderSummary ecoOrder={ecoOrder} />
}
